import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getManagerCredits = async (strategy) => {
  try {
    const token = getToken();

    const url = strategy
      ? `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/?strategy=${strategy}`
      : `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/`;

    const res = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return res;
  } catch (error) {
    console.error("Fleet manager credits fetch error:", error);
    throw error;
  }
};

const submitCreditTopUpRequest = async (formData) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/top-up-requests/`,
      formData,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Credit top-up request submit error:", error);
    throw error;
  }
};

const resubmitCreditTopUpRequest = async (id, formData) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/top-up-requests/?id=${id}`,
      formData,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Credit top-up request resubmit error:", error);
    throw error;
  }
};

const initiateWiPayTopUp = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/top-up-requests/wipay/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("WiPay top-up initiate error:", error);
    throw error;
  }
};

const finalizeCreditSettlement = async (strategy, data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/finalize/?strategy=${strategy}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Credit settlement finalize error:", error);
    throw error;
  }
};

const recalculateCreditAllocation = async (strategy, sensitivity) => {
  try {
    const token = getToken();

    const params = new URLSearchParams({ strategy });
    if (sensitivity !== undefined && sensitivity !== null) {
      params.append("sensitivity", sensitivity);
    }

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/recalculate/?${params.toString()}`,
      null,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Credit allocation recalculate error:", error);
    throw error;
  }
};

const getVehicleCreditDetail = async (vehicleId) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/?id=${vehicleId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle credit detail fetch error:", error);
    throw error;
  }
};

const getManagerModulesLookup = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/modules/lookup/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Manager modules lookup fetch error:", error);
    throw error;
  }
};

const updateFuelCardStatus = async (fuelCardId, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/fuel-card/?id=${fuelCardId}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel card status update error:", error);
    throw error;
  }
};

const submitVehicleCreditAdjustment = async (vehicleId, data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/credits/adjustments/?id=${vehicleId}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle credit adjustment submit error:", error);
    throw error;
  }
};

export {
  getManagerCredits,
  submitCreditTopUpRequest,
  resubmitCreditTopUpRequest,
  initiateWiPayTopUp,
  finalizeCreditSettlement,
  recalculateCreditAllocation,
  getVehicleCreditDetail,
  submitVehicleCreditAdjustment,
  getManagerModulesLookup,
  updateFuelCardStatus,
};
